
import { fromDob } from '~/util/date'

export default {
    props: {
        model: {
            type: Object,
            default: null
        },
    },
    computed: {
        age () {
            const dobx = fromDob(this.model?.dob)
            return dobx?.age_text
        },
        inactive () {
            return this.model?.active === false
        },
    },
}
